// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__65A8u","content":"style__content__i8vh-"};